export enum DownloadType {
  Routing = 'routing',
  Meteo = 'meteo',
  Meteogram = 'meteogram',
  FleetData = 'fleetData',
}
